import { TaskModel, WorkUserInfo, TimeClassifyEnum } from "@/types/work";
import {
  getPersonalList,
  queryTasks,
  editTaskItem,
  queryTaskGroups,
  queryTasksByTaskGroup,
  queryNoGroupTasks
} from "@/api/work";
import { message } from "antd";
import { decoratePersonalTask, getTimeClassifyByTime } from "@/components/Work/utils";

import {
  TaskListParams,
  TaskListByTaskGroupParams,
  IEditTaskItemParam,
  PROCESS_STATUS,
  TASK_STATUS,
  PRIORITY_TYPE,
  NewTaskModel,
  FIELD_SORT_TYPE
} from "@/types/newWork";
export enum WorkTabEnum {
  personal = "personal"
}

export enum MemberKeys {
  executors = "executors",
  subscribers = "subscribers"
}

export interface ITimeBlock {
  id: string;
  title: string;
  timeClassify: number;
  color: string;
  list: TaskModel[];
  total: number;
  lastTaskId: string;
}

interface State {
  tab: WorkTabEnum;
  personalTimeBlocks: ITimeBlock[];
  detailState: {
    drawVisible: boolean;
    taskId: string;
    drawEditVisible: string;
  };
  taskList: NewTaskModel[];
  taskStatuses: TASK_STATUS[];
  // taskGroupList?: [];
  // groupId: any;
}

/**
 * 从personalTimeBlocks里更新任务
 * @param param0
 */
function updatePersonalTask({
  state,
  task,
  timeBlockId
}: {
  state: State;
  task: TaskModel;
  timeBlockId: string;
}) {
  const { personalTimeBlocks } = state;
  const index0 = personalTimeBlocks.findIndex((t) => {
    if (timeBlockId) {
      return t.id === timeBlockId;
    }
    const index = t.list.findIndex((l) => l.taskId === task.taskId);
    return index > -1;
  });
  if (index0 === -1) {
    return personalTimeBlocks;
  }
  const timeBlock = { ...personalTimeBlocks[index0] };

  const { list } = timeBlock;
  const index = list.findIndex((l) => l.taskId === task.taskId);
  if (index === -1) {
    return personalTimeBlocks;
  }
  timeBlock.list = [...list];
  timeBlock.list.splice(index, 1, { ...task });
  const newPersonalTimeBlocks = [...personalTimeBlocks];
  newPersonalTimeBlocks.splice(index0, 1, timeBlock);
  return newPersonalTimeBlocks;
}

function deleteTaskFromTimeBlocks({
  timeBlocks,
  timeBlockId,
  taskId
}: {
  timeBlocks: ITimeBlock[];
  timeBlockId?: string;
  taskId: string;
}) {
  const index0 = timeBlocks.findIndex((t) => {
    if (timeBlockId) {
      return t.id === timeBlockId;
    }
    const index = t.list.findIndex((l) => l.taskId === taskId);
    return index > -1;
  });
  if (index0 === -1) {
    return timeBlocks;
  }
  const timeBlock = { ...timeBlocks[index0] };
  const list = [...timeBlock.list];
  const index = list.findIndex((l) => l.taskId === taskId);
  if (index === -1) {
    return timeBlocks;
  }
  timeBlock.list = list;
  timeBlock.list.splice(index, 1);
  timeBlock.total = timeBlock.total - 1;
  const newtimeBlocks = [...timeBlocks];
  newtimeBlocks.splice(index0, 1, timeBlock);
  return newtimeBlocks;
}

function addTemporyTaskFromTimeBlocks({
  timeBlocks,
  task
}: {
  timeBlocks: ITimeBlock[];
  task: TaskModel;
}) {
  const timeBlock = { ...timeBlocks[0] };
  timeBlock.list = [task, ...timeBlock.list];
  const newTimeBlocks = [...timeBlocks];
  newTimeBlocks.splice(0, 1, timeBlock);
  return newTimeBlocks;
}

function addTaskListFromTimeBlocks({
  timeBlockId,
  timeBlocks,
  tasks,
  offset,
  total,
  limit,
  lastTaskId,
  timeClassify
}: {
  timeBlocks: ITimeBlock[];
  timeBlockId: string;
  tasks: TaskModel[];
  offset: number;
  total: number;
  lastTaskId: string;
  limit: number;
  timeClassify: number;
}) {
  const timeBlock = timeBlocks[Number(timeBlockId)];
  const newList = offset === 0 ? [] : [...timeBlock.list];

  // 2. 更新对应的列表, 去重一下
  decoratePersonalTask(tasks).forEach((t) => {
    const index = newList.findIndex((n) => n.taskId === t.taskId);
    if (index === -1) {
      newList.push(t);
    } else {
      newList.splice(index, 1, t);
    }
  });
  timeBlock.list = newList;
  timeBlock.total = total;
  timeBlock.lastTaskId = lastTaskId;
  timeBlocks[Number(timeBlockId)] = { ...timeBlock };

  const tempBlock = timeBlocks[0];

  // 如果加载回来的数据少于请求数据，默认已经全部加载完成，更新total为本地总数，
  // 防止由于自动补齐10条的逻辑导致死循环加载数据，一般不会触发此操作，但是后台分页偶尔会出问题，导致拉取数量小于limit
  if (tasks.length < limit) {
    timeBlock.total = timeBlock.list.length;
  }

  // 如果有7天后时间块的更新，清空临时区域
  if (timeClassify === TimeClassifyEnum.LaterOrUntime) {
    tempBlock.list = [];
    tempBlock.total = 0;
  }
  return [...timeBlocks];
}

export default {
  namespace: "work",
  state: {
    tab: "personal",
    personalTimeBlocks: [
      {
        id: "0",
        title: "temporaryBlock",
        timeClassify: 0,
        list: [],
        total: 0, // 临时位置不需要总数
        color: "#EEEEEE"
      },
      {
        id: "1",
        title: "overdue",
        timeClassify: 1,
        list: [],
        total: 0,
        color: "#F6642D"
      },
      {
        id: "2",
        title: "today",
        color: "#8CCC48",
        timeClassify: 2,
        list: [],
        total: 0
      },
      {
        id: "3",
        title: "in week",
        color: "#379AFF",
        timeClassify: 3,
        list: [],
        total: 0
      },
      {
        id: "4",
        title: "later or untime",
        color: "#4751C8",
        timeClassify: 4,
        list: [],
        total: 0
      },
      {
        id: "5",
        title: "finished",
        color: "#8899A4",
        timeClassify: 5,
        list: [],
        total: 0
      }
    ],
    teamTimeBlocks: [
      {
        id: "0",
        title: "temporaryBlock",
        timeClassify: 0,
        list: [],
        total: 0, // 临时位置不需要总数
        color: "#EEEEEE"
      },
      {
        id: "1",
        title: "overdue",
        timeClassify: 1,
        list: [],
        total: 0,
        color: "#F6642D"
      },
      {
        id: "2",
        title: "today",
        color: "#8CCC48",
        timeClassify: 2,
        list: [],
        total: 0
      },
      {
        id: "3",
        title: "in week",
        color: "#379AFF",
        timeClassify: 3,
        list: [],
        total: 0
      },
      {
        id: "4",
        title: "later or untime",
        color: "#4751C8",
        timeClassify: 4,
        list: [],
        total: 0
      },
      {
        id: "5",
        title: "finished",
        color: "#8899A4",
        timeClassify: 5,
        list: [],
        total: 0
      }
    ],
    detailState: {
      drawVisible: false,
      taskId: "",
      fullIframeModalVisible: false,
      fullIframeModalUrl: "",
      forceGet: false,
      activeTab: "/basicInfo",
      drawEditVisible: false,
      taskComeFrom: ""
    },
    taskList: [],
    total: 0,
    offset: 0,
    offsets: [0], // 存储offset
    processStatuses: [],
    taskStatuses: [1],
    priorityTypes: [1, 2, 3, 4],
    userRole: null,
    fieldSortType: 1,
    taskLoading: false,
    taskGroupList: [],
    groupId: "", // 任务组id
    archiveTaskGroupList: [], // 已归档的任务组
    activeKey: "all_task-undefined", // 默认选中的任务导航
    taskGroupIds: []
  },
  reducers: {
    setTaskLoading(state: any, { payload }: { payload: boolean }) {
      return { ...state, taskLoading: payload };
    },
    changeTab(state: State, { payload }: { payload: { tab: WorkTabEnum } }) {
      const { tab } = payload;
      return { ...state, tab };
    },
    setOffset(state: any, { payload }: { payload: number }) {
      return {
        ...state,
        offset: payload
      };
    },
    setOffsets(state: any, { payload }: { payload: number[] }) {
      return {
        ...state,
        offsets: payload
      };
    },
    setProcessStatus(state: any, { payload }: { payload: PROCESS_STATUS[] }) {
      return {
        ...state,
        offsets: [0],
        offset: 0,
        processStatuses: payload
      };
    },
    setUserRole(state: any, { payload }: { payload: number }) {
      return {
        ...state,
        offsets: [0],
        offset: 0,
        userRole: payload
      };
    },
    setFieldSortType(state: any, { payload }: { payload: number }) {
      return {
        ...state,
        offsets: [0],
        offset: 0,
        fieldSortType: payload
      };
    },
    setTaskStatus(state: any, { payload }: { payload: TASK_STATUS[] }) {
      return {
        ...state,
        offsets: [0],
        offset: 0,
        taskStatuses: payload
      };
    },
    setPriorities(state: any, { payload }: { payload: PRIORITY_TYPE[] }) {
      return {
        ...state,
        offsets: [0],
        offset: 0,
        priorityTypes: payload
      };
    },
    setActiveKey(state: any, { payload }: { payload: string }) {
      return {
        ...state,
        activeKey: payload
      };
    },
    /**
     * 打开或关闭个人任务详情侧边栏
     * 变更显示的侧边栏
     */
    changeFullIframeModal(
      state: State,
      { payload }: { payload: { fullIframeModalVisible: boolean; fullIframeModalUrl: string } }
    ) {
      return {
        ...state,
        detailState: {
          ...state.detailState,
          ...payload
        }
      };
    },
    /**
     * 打开或关闭个人任务详情侧边栏
     * 变更显示的侧边栏
     */
    changePersonalTaskDraw(
      state: State,
      {
        payload
      }: {
        payload: {
          drawVisible: boolean;
          taskId: string;
          forceGet: boolean;
          activeTab: string;
          taskComeFrom?: string;
          chat: boolean;
        };
      }
    ) {
      const { drawVisible, taskId, activeTab, chat, taskComeFrom } = payload;
      return {
        ...state,
        detailState: {
          drawVisible,
          taskId,
          chat,
          forceGet: !!payload.forceGet,
          activeTab: activeTab,
          taskComeFrom
        }
      };
    },
    /**
     * 打开或关闭个人任务详情侧边栏
     * 变更显示的侧边栏
     */
    changeEditTaskDraw(
      state: State,
      {
        payload
      }: {
        payload: {
          taskId: string;
          drawEditVisible: boolean;
          taskDetail?: NewTaskModel;
        };
      }
    ) {
      const { drawEditVisible, taskId, taskDetail } = payload;
      return {
        ...state,
        detailState: {
          drawEditVisible,
          taskId,
          taskDetail
        }
      };
    },
    /**
     * 添加列表到对应时间块
     */
    setPersonalTaskList(
      state: State,
      {
        payload
      }: {
        payload: {
          timeBlockId: string;
          timeClassify: number;
          tasks: TaskModel[];
          total: number;
          lastTaskId: string;
          offset: number;
          limit: number;
        };
      }
    ) {
      const { personalTimeBlocks } = state;
      const timeBlocks = addTaskListFromTimeBlocks({
        timeBlocks: personalTimeBlocks,
        ...payload
      });

      return {
        ...state,
        personalTimeBlocks: timeBlocks
      };
    },
    setTaskList(
      state: State,
      {
        payload
      }: {
        payload: {
          tasks: NewTaskModel[];
          total: number;
          offset: number;
          limit: number;
        };
      }
    ) {
      let localList: NewTaskModel[] = [];
      const { tasks, total, offset } = payload;
      if (offset > 0) {
        // 去重
        state.taskList.concat(tasks).forEach((item) => {
          let temp = localList.find((k) => k.taskId === item.taskId);
          if (temp) {
            // @ts-ignore
            temp = { ...temp, ...item };
          } else {
            localList.push(item);
          }
        });
      } else {
        localList = tasks;
      }
      return {
        ...state,
        total,
        taskList: localList,
        taskLoading: false
      };
      // const { tasks, total } = payload;
      // return {
      //     ...state,
      //     total,
      //     taskList: tasks,
      // };
    },
    setTaskItem(state: State, { payload }: any) {
      const lastTaskList = state.taskList?.map((item) => {
        if (item.taskId === payload.taskId) {
          // eslint-disable-next-line no-param-reassign
          item = Object.assign(item, payload, {
            priorityType: payload.priorityType || -1
          });
        }
        return item;
      });
      return {
        ...state,
        taskList: lastTaskList
      };
    },
    setTaskGroupsList(state: State, { payload }: { payload: any }) {
      const { taskGroupList, archiveTaskGroupList } = payload;
      return {
        ...state,
        taskGroupList: taskGroupList,
        archiveTaskGroupList: archiveTaskGroupList
      };
    },
    commonSetter(state: State, { payload }: { payload: any }) {
      const { groupId } = payload;
      return {
        ...state,
        groupId: groupId
      };
    },
    // 清空数据
    clearData(state: State) {
      return {
        ...state,
        taskList: [],
        total: 0,
        offset: 0,
        offsets: [0], // 存储offset
        processStatuses: [],
        taskStatuses: [1],
        priorityTypes: [1, 2, 3, 4]
      };
    }
  },
  effects: {
    *getWebUserData({ payload }: any, { call, put }: any) {
      const result = payload.userData;
      yield put({
        type: "setUserData",
        // payload: {
        //     ...result,
        //     team: result.teamUserInfo,
        //     teamUserInfoList: [result.teamUserInfo],
        //     selectedTeamId: result.teamUserInfo.teamId,
        // },
        payload: {
          user: {
            ...result,
            team: result.teamUserInfo,
            teamUserInfoList: [result.teamUserInfo],
            selectedTeamId: result.teamUserInfo.teamId
          }
        }
      });
      // yield put({ type: 'setUserInfo', payload: result });
    },
    *getMyTasksByTime(
      {
        payload
      }: {
        payload: {
          endTimeFrom?: string;
          endTimeTo?: string;
          timeBlockId?: string;
          offset: number;
          limit: number;
          // timeClassify?: number;
        };
      },
      { call, put }: any
    ) {
      const { endTimeFrom, endTimeTo, timeBlockId, offset, limit } = payload;
      const result = yield call(getPersonalList, payload);
      const [data, err] = result;
      if (err || !data) {
        message.error(err);
        return;
      }
      yield put({
        type: "setPersonalTaskList",
        payload: {
          timeBlockId,
          ...data,
          offset,
          limit,
          timeClassify: Number(timeBlockId)
        }
      });
    },
    *asyncSetTaskLoading({ payload }: { payload: boolean }, { put }: any) {
      yield put({
        type: "setTaskLoading",
        payload: payload
      });
    },
    *asyncSetTaskList(
      {
        payload
      }: {
        payload: {
          tasks: NewTaskModel[];
          total: number;
          offset: number;
          limit: number;
        };
      },
      { put }: any
    ) {
      yield put({
        type: "setTaskList",
        payload
      });
    },
    *fetchTaskList(
      {
        payload
      }: {
        payload: TaskListParams;
      },
      { call, put }: any
    ) {
      // TODO: 其实这里都没有offsets
      const { limit, offsets, offset } = payload;
      let res: { total: number; tasks: NewTaskModel[] } = {
        total: 0,
        tasks: []
      };
      yield put({
        type: "asyncSetTaskLoading",
        payload: true
      });
      console.log("其实这里都没有offsets", payload);
      if (offsets) {
        for (const offset of offsets) {
          const [data, err] = yield call(queryTasks, { ...payload, offset });
          if (err || !data) {
            message.error(err || "服务器错误");
            return;
          }
          const { total, tasks } = data;
          res = { total, tasks: [...res.tasks, ...tasks] };
        }
      } else {
        const [data, err, isOffline] = yield call(queryTasks, payload);
        if (err || !data) {
          message.error(err || "服务器错误");
          if (isOffline) {
            yield put({
              type: "asyncSetTaskLoading",
              payload: false
            });
          }
          return;
        }
        res = data;
      }

      yield put({
        type: "asyncSetTaskList",
        payload: {
          ...res,
          offset,
          offsets,
          limit,
          tasks: res.tasks || []
        }
      });
    },
    *fetchTaskListByTaskGroup(
      {
        payload
      }: {
        payload: TaskListByTaskGroupParams;
      },
      { call, put }: any
    ) {
      // TODO: 其实这里都没有offsets
      const { limit, offsets, offset } = payload;
      let res: { total: number; tasks: NewTaskModel[] } = {
        total: 0,
        tasks: []
      };
      yield put({
        type: "asyncSetTaskLoading",
        payload: true
      });
      console.log("其实这里都没有offsets", payload);
      if (offsets) {
        for (const offset of offsets) {
          const [data, err] = yield call(
            payload.groupId ? queryTasksByTaskGroup : queryNoGroupTasks,
            { ...payload, offset }
          );
          if (err || !data) {
            message.error(err || "服务器错误");
            return;
          }
          const { total, tasks } = data;
          res = { total, tasks: [...res.tasks, ...tasks] };
        }
      } else {
        const [data, err, isOffline] = yield call(
          payload.groupId ? queryTasksByTaskGroup : queryNoGroupTasks,
          payload
        );
        if (err || !data) {
          message.error(err || "服务器错误");
          if (isOffline) {
            yield put({
              type: "asyncSetTaskLoading",
              payload: false
            });
          }
          return;
        }
        res = data || {};
      }
      yield put({
        type: "asyncSetTaskList",
        payload: {
          ...res,
          offset,
          offsets,
          limit,
          tasks: res?.tasks || []
        }
      });
    },
    *editTaskItem({ payload }: { payload: IEditTaskItemParam }, { call, put }: any) {
      const result = yield call(editTaskItem, payload);
      const [data, err] = result;
      if (err || !data) {
        message.error(err);
        return;
      }
      yield put({
        type: "setTaskItem",
        payload: {
          ...data
        }
      });
    },
    *queryTaskGroupsList(payload: any, { call, put }: any) {
      const result = yield call(queryTaskGroups);
      const [data, err] = result;
      // eslint-disable-next-line no-debugger
      // debugger;
      if (err) {
        message.error(err);
        return;
      }
      yield put({
        type: "setTaskGroupsList",
        payload: {
          taskGroupList: data?.taskGroupResList || [],
          archiveTaskGroupList: data?.archiveTaskGroupResList || []
        }
      });
    }
  }
};
